module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/spot_02@3x-1779e7c5a00f00a80d6ffb8869c00997.webp";